import React from 'react'
import { Modal as BsModal } from 'react-bootstrap';

interface Props { 
    id?: string,
    title: String,
    show: Boolean,
    promtHide?: Boolean,
    promtHideMessage?: String,
    style?: React.CSSProperties,
    size?: "sm" | "lg" | "xl",
    onHide: {() : void}
};
interface State { };

export default class Modal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { 
    };
  }

  render() {
    const { id, title, children, style, size } = this.props;

    return (
      <div className="render-modal" style={{ ...style }}>
          <BsModal 
            id={id}
            show={this.props.show}
            onHide={() => { this.props.onHide(); }}
            backdropClassName={"static"}
            className={`bsModal ${size ? '' : 'bsModal-default-size'}`}
            size={size}
          >
            <BsModal.Header closeButton className="bsModal-header">
                <BsModal.Title className="bsModal-header-title">
                    { title }
                </BsModal.Title>
            </BsModal.Header>
            <BsModal.Body className="bsModal-body">
                { children }
            </BsModal.Body>
          </BsModal>
      </div>
    );
  }
}